<template>
  <div class="p-grid p-mb-0">
		<div class="p-col-12 p-pt-1 p-pb-0">
        <h2>{{$t('bot.title')}}</h2>
        <div class="chatbot-container">
          <ChatBot/>
        </div>
    </div>
  </div>
</template>

<script>
import ChatBot from './ChatBot';
import { mapGetters } from 'vuex';
import AiService from '../../service/AiService';

export default {
  components: {
        ChatBot,
    },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
    }),
  },
  created() {
    this.aiService = new AiService();
  },
  mounted() {
  },
  unmounted() {
    // this.aiService.botDeleteChatSessionHistory(this.personaltoken);
    this.$store.commit('ai/clearChatBotMessages');
  },
  methods: {
  }

}
</script>

<style lang="scss" scoped>

.chatbot-container {
  height: calc(100vh - 220px);
}

</style>